import { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

const SetupProfilePoints: FC<IllustrationProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="SetupProfilePoints"
      illustration={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={restProps?.width ?? "24"}
          height={restProps?.height ?? "24"}
          viewBox="0 0 48 48"
          fill="none"
          {...props}
        >
          <circle cx="24" cy="24" r="24" fill="#F1BEF9" />
          <mask
            id="mask0_8582_29967"
            style={{ maskType: "alpha" }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="48"
            height="48"
          >
            <circle cx="24" cy="24" r="24" fill="#F1BEF9" />
          </mask>
          <g mask="url(#mask0_8582_29967)">
            <path
              d="M23.5928 49.784C19.7174 50.0055 17.7491 47.0861 17.5556 45.2476C17.5556 45.2476 23.6638 45.9593 29.5167 45.0835C29.5167 45.0835 29.01 49.4739 23.572 49.7841L23.5928 49.784Z"
              fill="url(#paint0_linear_8582_29967)"
            />
            <path
              d="M22.3235 49.0641C18.2807 49.0772 14.8276 45.7581 10.7195 44.9145L10.24 44.8325C8.96804 44.6067 7.14551 43.9095 6.68312 42.6989C6.15761 41.3003 7.09212 40.2942 8.06904 39.5178C8.83812 38.9092 8.88549 38.4209 9.06871 37.0828C9.25186 35.7238 9.14903 31.4026 8.90951 28.2267C8.80132 26.994 8.78162 24.7784 8.75868 24.1306C8.64846 22.271 10.0372 20.8204 11.2422 19.688C11.5537 19.3735 11.7614 19.1638 11.9068 18.9961C11.7194 19.0385 11.5944 19.0599 11.4902 19.0602L11.2401 19.061L11.1767 18.7686C11.1754 18.3924 12.0084 18.2017 12.2168 18.201C12.3418 18.2006 12.4461 18.2211 12.5088 18.2836C13.3208 18.0511 14.112 17.8396 14.945 17.6697C16.0696 17.457 17.2363 17.3697 18.3405 17.2825C18.778 17.2393 19.2364 17.2169 19.6739 17.1737C20.1947 17.1302 20.7363 17.0657 21.2571 17.0014C22.507 16.851 23.7777 16.7006 25.0697 16.6964C25.2989 16.6957 25.5281 16.6949 25.7574 16.6942C28.7169 16.81 31.6588 17.9081 34.0614 19.7812C35.0224 20.5305 34.8277 20.2144 35.2487 21.4879C35.7326 22.9075 35.771 22.0911 35.6288 23.2201C35.5066 24.0983 35.9767 27.2052 35.8545 28.0833C35.6095 29.6515 36.0836 32.8992 35.9846 34.5087C35.9048 35.6166 35.9825 36.8671 36.1107 37.8489C36.1962 38.4965 36.5349 39.193 36.8908 39.7143C37.0374 39.9438 37.2256 40.1312 37.4347 40.3395C37.7692 40.6728 38.1037 41.0061 38.2719 41.4654C38.5034 42.1752 38.4846 42.8022 38.1945 43.3256C37.5937 44.4143 36.2066 45.9584 35.2487 46.1705C31.438 47.0606 28.034 49.0511 24.0121 49.0641L22.3235 49.0641Z"
              fill="url(#paint1_linear_8582_29967)"
            />
            <path
              d="M20.0905 13.0366C21.3287 13.0326 22.3292 12.0227 22.3251 10.781C22.3211 9.53925 21.3141 8.53588 20.0759 8.53989C18.8377 8.5439 17.8372 9.55377 17.8413 10.7955C17.8453 12.0372 18.8523 13.0406 20.0905 13.0366Z"
              fill="#F364FF"
            />
            <path
              d="M35.1829 16.5101C33.2274 19.2626 33.4146 15.7995 33.3349 15.7003C30.6417 11.2316 25.021 9.57831 19.8848 10.5302C16.712 11.1176 13.6222 12.8588 11.5072 15.373C8.83872 18.5456 8.63238 22.2276 8.48653 26.2079C11.0634 25.3837 13.2999 23.6453 15.7165 22.344L31.2815 18.851C31.2815 18.851 37.2768 13.5981 35.2027 16.5101L35.1829 16.5101Z"
              fill="url(#paint2_linear_8582_29967)"
            />
            <path
              d="M35.5279 24.2711C35.5279 24.2711 28.5771 17.9194 8.53342 26.1322C8.53342 26.1322 21.9204 15.1814 35.2548 14.4127C35.2548 14.4127 47.0866 13.5931 45.3787 18.8817C44.1665 22.6247 35.5464 24.271 35.5464 24.271L35.5279 24.2711Z"
              fill="#1E1E2B"
            />
            <path
              d="M8.18542 28.12C8.06074 28.2249 8.06392 29.207 8.12758 29.562C8.12758 29.562 8.25246 29.5198 8.43986 29.4774C10.1468 28.9495 11.7294 28.6518 13.3109 27.9989C13.3309 27.7272 12.7036 27.0605 12.7862 26.8095C12.5358 26.7267 8.45555 27.8892 8.18549 28.1409L8.18542 28.12Z"
              fill="#2D2C3D"
            />
            <path
              d="M12.2871 27.02C12.5157 26.8312 12.8281 26.7675 13.1198 26.7457C13.1615 26.7455 13.2031 26.7454 13.2448 26.7452C14.4115 26.6579 15.5577 26.6542 16.7246 26.6295C18.0583 26.6252 19.3711 26.6209 20.7048 26.6166C21.4759 26.6141 22.2262 26.6535 22.9974 26.6928C23.4142 26.7123 23.8726 26.6899 24.269 26.8349C24.6446 26.98 24.9167 27.3344 25.3128 27.3958C25.7507 27.478 26.1247 27.1424 26.4993 26.9949C28.206 26.3206 30.5201 26.6266 32.3123 26.6208C33.4167 26.6172 34.5421 26.6345 35.6467 26.6727C36.1885 26.6709 36.7513 26.7109 37.2931 26.7092C37.7724 26.7076 38.46 26.6845 38.8364 27.0803C39.171 27.4345 38.9437 28.0413 38.6738 28.3348C38.3622 28.6493 38.3221 29.151 38.3027 29.569C38.1843 31.6175 36.8981 33.4399 35.0671 34.3235C33.4443 35.123 31.048 35.1934 29.4616 34.3835C28.4596 33.8643 27.7065 32.9681 27.224 31.9665C26.8462 31.1526 26.7602 30.317 26.5282 29.4609C26.3805 28.8971 25.8582 28.5017 25.2543 28.629C24.1714 28.8624 24.0305 30.3885 23.6998 31.2464C22.3973 34.4482 18.6513 35.9859 15.4993 34.366C15.3949 34.3037 15.2906 34.2622 15.1862 34.1998C13.5157 33.1603 12.8009 31.2399 12.5865 29.3806C12.5224 28.9002 12.5424 28.6493 12.0625 28.4419C12.0416 28.442 11.9999 28.4212 11.9789 28.3795C11.9788 28.3586 11.9788 28.3377 11.9786 28.2959C11.9773 27.8779 11.9336 27.272 12.287 26.9991L12.2871 27.02Z"
              fill="#2D2C3D"
            />
            <path
              d="M28.2941 27.6997C28.1691 27.7001 28.0441 27.7005 27.9609 27.7635C27.7529 27.8686 27.7329 28.1404 27.7127 28.3494C27.6147 30.2515 28.3927 32.4016 30.2087 33.3153C31.5028 33.9589 33.232 33.8071 34.5222 33.2386C35.9164 32.628 36.8295 31.4338 37.1373 29.9699C37.2195 29.6144 37.6939 28.0872 37.089 27.922C36.4424 27.7569 30.5859 27.5251 28.3149 27.6787L28.2941 27.6997Z"
              fill="#1E1E2B"
            />
            <mask
              id="mask1_8582_29967"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="27"
              y="27"
              width="11"
              height="7"
            >
              <path
                d="M28.2941 27.6997C28.1691 27.7001 28.0441 27.7005 27.9609 27.7635C27.7529 27.8686 27.7329 28.1404 27.7127 28.3494C27.6147 30.2515 28.3927 32.4016 30.2087 33.3153C31.5028 33.9589 33.232 33.8071 34.5222 33.2386C35.9164 32.628 36.8295 31.4338 37.1373 29.9699C37.2195 29.6144 37.6939 28.0872 37.089 27.922C36.4424 27.7569 30.5859 27.5251 28.3149 27.6787L28.2941 27.6997Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask1_8582_29967)">
              <path
                d="M34.7157 28.7446C34.737 28.8908 34.7583 29.0371 34.7587 29.1833C34.7619 30.1655 33.9086 30.4817 33.4527 31.2354C32.6651 32.5336 34.5022 33.5934 35.4205 34.071C35.8797 34.3203 36.3597 34.5277 36.8395 34.7142C36.4244 35.2171 35.6955 35.3239 35.0288 35.347C34.3828 35.3491 33.7991 35.2674 33.1944 35.123C32.6105 34.9787 32.0046 34.5 31.5659 34.1253C30.8972 33.5423 30.1436 32.4791 30.5156 31.5375C30.743 30.9726 31.3046 30.6573 31.5528 30.0923C31.7389 29.6528 31.5914 29.1309 31.2985 28.7766C30.8383 28.2348 30.3158 27.7558 29.7104 27.3817C30.064 27.1925 30.4804 27.1075 30.8551 26.9809C31.2714 26.8333 31.7085 26.7065 32.1458 26.6006C32.5413 26.4948 32.9787 26.4307 33.3335 26.5968C33.5213 26.7006 33.6677 26.8673 33.8141 27.034C34.2116 27.5134 34.5885 28.0973 34.6948 28.7238L34.7157 28.7446Z"
                fill="#FAFAFA"
              />
            </g>
            <path
              d="M23.106 27.9255C23.7109 28.0907 23.2156 29.597 23.1543 29.9734C22.8464 31.4164 21.9334 32.6315 20.5392 33.2421C19.249 33.8106 17.5198 33.9624 16.2257 33.3188C14.4097 32.4051 13.6317 30.255 13.7297 28.3529C13.729 28.123 13.7699 27.8721 13.9779 27.767C14.0819 27.7039 14.2069 27.7035 14.3111 27.7032C16.5822 27.5704 22.4387 27.7814 23.0852 27.9464L23.106 27.9255Z"
              fill="#1E1E2B"
            />
            <mask
              id="mask2_8582_29967"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="13"
              y="27"
              width="11"
              height="7"
            >
              <path
                d="M23.106 27.9255C23.7109 28.0907 23.2156 29.597 23.1543 29.9734C22.8464 31.4164 21.9334 32.6315 20.5392 33.2421C19.249 33.8106 17.5198 33.9624 16.2257 33.3188C14.4097 32.4051 13.6317 30.255 13.7297 28.3529C13.729 28.123 13.7699 27.8721 13.9779 27.767C14.0819 27.7039 14.2069 27.7035 14.3111 27.7032C16.5822 27.5704 22.4387 27.7814 23.0852 27.9464L23.106 27.9255Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask2_8582_29967)">
              <path
                d="M20.5218 27.9965C20.5431 28.1427 20.5644 28.2889 20.5649 28.4352C20.5681 29.4173 19.7148 29.7335 19.2588 30.4873C18.4712 31.7854 20.3083 32.8452 21.2267 33.3228C21.6859 33.5721 22.1658 33.7795 22.6457 33.966C22.2306 34.4689 21.5016 34.5757 20.8349 34.5988C20.189 34.6009 19.6053 34.5192 19.0005 34.3749C18.4166 34.2305 17.8108 33.7518 17.372 33.3771C16.7033 32.7942 15.9498 31.7309 16.3218 30.7893C16.5492 30.2244 17.1107 29.9091 17.3589 29.3441C17.5451 28.9047 17.3975 28.3827 17.1046 28.0284C16.6445 27.4866 16.122 27.0077 15.5165 26.6335C15.8701 26.4443 16.2866 26.3594 16.6612 26.2328C17.0775 26.0851 17.5147 25.9583 17.9519 25.8524C18.3475 25.7467 18.7848 25.6826 19.1396 25.8486C19.3275 25.9525 19.4739 26.1192 19.6203 26.2859C20.0177 26.7652 20.3947 27.3491 20.5009 27.9756L20.5218 27.9965Z"
                fill="#FAFAFA"
              />
            </g>
            <path
              d="M28.7389 36.6428C28.7389 36.6428 28.6966 36.4757 28.6132 36.4551C26.2361 35.9404 20.7582 36.6268 20.6335 36.7317C20.4258 36.9204 20.8278 38.8207 20.9757 39.4263C21.7558 42.2657 24.7365 42.5695 26.6916 41.4556C28.3554 40.489 28.7226 38.0429 28.7389 36.6637L28.7389 36.6428Z"
              fill="#332016"
            />
            <mask
              id="mask3_8582_29967"
              style={{ maskType: "luminance" }}
              maskUnits="userSpaceOnUse"
              x="20"
              y="36"
              width="9"
              height="7"
            >
              <path
                d="M28.7389 36.6428C28.7389 36.6428 28.6966 36.4757 28.6132 36.4551C26.2361 35.9404 20.7582 36.6268 20.6335 36.7317C20.4258 36.9204 20.8278 38.8207 20.9757 39.4263C21.7558 42.2657 24.7365 42.5695 26.6916 41.4556C28.3554 40.489 28.7226 38.0429 28.7389 36.6637L28.7389 36.6428Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask3_8582_29967)">
              <path
                d="M27.9929 37.9616C26.6823 38.6136 23.7022 38.4979 22.3681 38.335C20.8464 38.1519 20.9275 37.4411 20.2768 35.9805C20.2138 35.8344 20.1507 35.6466 20.2336 35.5209C20.2959 35.4371 20.3999 35.395 20.5039 35.3529C21.0868 35.1838 21.691 35.14 22.2743 35.0964C24.1284 34.9859 25.9829 35.0008 27.8382 35.2455C28.0884 35.2865 28.0047 35.1823 28.2343 35.3069C28.9442 35.7434 28.6793 37.6041 27.9928 37.9407L27.9929 37.9616Z"
                fill="white"
              />
              <path
                d="M23.9962 39.2914C25.3938 39.7466 26.6473 40.7456 26.3394 42.1885C26.2982 42.3558 26.2362 42.5023 26.1324 42.628C26.0494 42.7118 25.9245 42.754 25.7996 42.7962C24.8213 43.1338 23.7367 42.8029 22.7562 42.43C22.2346 42.2227 21.7129 41.9945 21.295 41.6197C20.7308 41.12 19.9797 40.8299 20.0606 40.0774C20.1418 39.4293 21.1204 39.1754 21.6409 39.0692C22.2865 38.9417 23.1619 39.0225 23.9962 39.2914Z"
                fill="#FF428D"
              />
            </g>
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_8582_29967"
              x1="29.0557"
              y1="45.816"
              x2="-6.95677"
              y2="53.3528"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#CD45FF" />
              <stop offset="0.05" stopColor="#BE48F9" />
              <stop offset="0.12" stopColor="#9A50EC" />
              <stop offset="0.2" stopColor="#7C57E1" />
              <stop offset="0.29" stopColor="#655CD9" />
              <stop offset="0.38" stopColor="#5560D3" />
              <stop offset="0.48" stopColor="#4C62D0" />
              <stop offset="0.61" stopColor="#4963CF" />
              <stop offset="0.68" stopColor="#4868CE" />
              <stop offset="0.76" stopColor="#4777CC" />
              <stop offset="0.84" stopColor="#4691C9" />
              <stop offset="0.94" stopColor="#43B4C6" />
              <stop offset="1" stopColor="#42D1C3" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_8582_29967"
              x1="16.789"
              y1="24.7555"
              x2="33.3504"
              y2="52.8289"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF94A6" />
              <stop offset="0.51" stopColor="#E03DC1" />
              <stop offset="1" stopColor="#8247E5" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_8582_29967"
              x1="28.391"
              y1="13.7116"
              x2="-37.5764"
              y2="35.6202"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.02" stopColor="#CD45FF" />
              <stop offset="0.05" stopColor="#BE48F9" />
              <stop offset="0.12" stopColor="#9A50EC" />
              <stop offset="0.2" stopColor="#7C57E1" />
              <stop offset="0.29" stopColor="#655CD9" />
              <stop offset="0.38" stopColor="#5560D3" />
              <stop offset="0.48" stopColor="#4C62D0" />
              <stop offset="0.61" stopColor="#4963CF" />
              <stop offset="0.68" stopColor="#4868CE" />
              <stop offset="0.76" stopColor="#4777CC" />
              <stop offset="0.84" stopColor="#4691C9" />
              <stop offset="0.94" stopColor="#43B4C6" />
              <stop offset="1" stopColor="#42D1C3" />
            </linearGradient>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};

export default SetupProfilePoints;
